import createSliderWithTooltip from 'rc-slider/lib/createSliderWithTooltip';

export default createSliderWithTooltip;



/** WEBPACK FOOTER **
 ** ./components/create-tooltip/index.web.tsx
 **/